import React from 'react';
import {
  ChevronLeft,
  ChevronRight,
  LayoutDashboard,
  Users,
  Gauge,
  CreditCard,
  Truck,
  FileText,
  Wrench,
  DollarSign,
  LogOut,
  Sun,
  Moon,
} from 'lucide-react';

const Sidebar = ({ onSelect, selected, isOpen, setOpen, onLogout, theme, toggleTheme }) => {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    // { type: 'heading', label: 'Onboarding' },
    { type: 'heading', label: 'Management' },

    { id: 'onboarding', label: 'Partner Management', icon: Users },
    { id: 'vehicles', label: 'Vehicle Management', icon: Truck },
    { id: 'rm-onboarding', label: 'RM Onboarding', icon: Users },

    { type: 'heading', label: 'Financials' },
    // { id: 'cash-collection', label: 'Cash Collection', icon: DollarSign },
    { id: 'transactions', label: 'Vehicle Transactions', icon: CreditCard },
    { type: 'heading', label: 'System' },
    { id: 'maintenance', label: 'Maintenance', icon: Wrench },
    { id: 'juspay', label: 'Juspay Logs', icon: FileText },
    { id: 'odometer', label: 'Odometer Readings', icon: Gauge },
  ];

  return (
    <aside
      className={`bg-white dark:bg-neutral-900 text-neutral-900 dark:text-white h-screen shadow-lg transition-all duration-300 ease-in-out ${isOpen ? 'w-64' : 'w-20'} border-r border-neutral-200 dark:border-neutral-800 flex flex-col`}
    >
      <div className="flex items-center justify-between p-4 border-b border-neutral-200 dark:border-neutral-800">
        {isOpen && (
          <span className="text-xl font-bold text-primary-700 dark:text-primary-500">
            LTD Fleet
          </span>
        )}
        <button
          onClick={() => setOpen(!isOpen)}
          className="p-2 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800"
        >
          {isOpen ? <ChevronLeft /> : <ChevronRight />}
        </button>
      </div>
      <nav className="mt-4 flex-1 overflow-y-auto">
        <ul>
          {navItems.map((item, index) => (
            <li key={index} className="px-4 py-1">
              {item.type === 'heading' ? (
                isOpen && (
                  <h3 className="text-xs font-bold text-neutral-400 uppercase tracking-wider mt-4 mb-2">
                    {item.label}
                  </h3>
                )
              ) : (
                <button
                  type="button"
                  onClick={() => onSelect(item.id)}
                  className={`w-full flex items-center p-3 text-base font-normal rounded-lg transition-colors duration-200 text-left ${
                    selected === item.id
                      ? 'bg-primary-600 text-white shadow-lg'
                      : 'text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800'
                  }`}
                >
                  <item.icon className="w-6 h-6" />
                  {isOpen && (
                    <span className="ml-4 font-medium">{item.label}</span>
                  )}
                </button>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <div className="p-4 border-t border-neutral-200 dark:border-neutral-800 space-y-2">
        <button
          onClick={toggleTheme}
          className="w-full flex items-center p-3 text-base font-normal text-neutral-700 dark:text-neutral-300 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors duration-200 text-left"
        >
          {theme === 'dark' ? <Sun className="w-6 h-6" /> : <Moon className="w-6 h-6" />}
          {isOpen && <span className="ml-4 font-medium">Toggle Theme</span>}
        </button>
        <button
          onClick={onLogout}
          className="w-full flex items-center p-3 text-base font-normal text-neutral-700 dark:text-neutral-300 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors duration-200 text-left"
        >
          <LogOut className="w-6 h-6" />
          {isOpen && <span className="ml-4 font-medium">Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
